import shrimpImg from "../image/svg/shrimp.svg";
import crabImg from "../image/svg/crab.svg";
import octupusImg from "../image/svg/octopus.svg";
import fishImg from "../image/svg/fish.svg";
import whaleImg from "../image/svg/whale.svg";
import dolphineImg from "../image/svg/dolphine.svg";
import humpbackImg from "../image/svg/humpback.svg";
import sharkImg from "../image/svg/shark.svg"

export const userLevels = [
    {
        level: 1,
        name: "Shrimp",
        minDeodHoldings: 0.00000000001,
        image: shrimpImg,
    },
    {
        level: 2,
        name: "Crab",
        minDeodHoldings: 100000,
        image: crabImg,
    },
    {
        level: 3,
        name: "Octopus",
        minDeodHoldings: 200000,
        image: octupusImg,
    },
    {
        level: 4,
        name: "Fish",
        minDeodHoldings: 500000,
        image: fishImg,
    },
    {
        level: 5,
        name: "Dolphin",
        minDeodHoldings: 1000000,
        image: dolphineImg,
    },
    {
        level: 6,
        name: "Shark",
        minDeodHoldings: 2500000,
        image: sharkImg,
    },
    {
        level: 7,
        name: "Whale",
        minDeodHoldings: 10000000,
        image: whaleImg,
    },
    {
        level: 8,
        name: "Humpback",
        minDeodHoldings: 50000000,
        image: humpbackImg,
    },
];


export const getUserLevel = (holdings) => {
    if (holdings == null) return null;
    for (let i = userLevels.length - 1; i >= 0; i--) {
        if (holdings >= userLevels[i].minDeodHoldings) {
            return userLevels[i];
        }
    }
    return userLevels[0];
};